import {
  createPermissionGuard,
  type PermissionGuardBaseProps,
} from '@gokrew/ui';
import { usePermissions } from '@/context/PermissionContext';
import type { EmployeePermissionScope } from '@gokrew/models/employee-permissions';

export type PermissionGuardProps = Omit<
  PermissionGuardBaseProps<
    EmployeePermissionScope,
    Set<Partial<EmployeePermissionScope>>
  >,
  'permissions'
>;

export const PermissionGuard = createPermissionGuard<
  EmployeePermissionScope,
  Set<Partial<EmployeePermissionScope>>
>(usePermissions);
